export default function getCookie() {
  const cookies = {
    domain: 'tassomutuo.it',
    urlpath: '/',
    utcscandate: '2023-07-30T08:36:40.3770000Z',
    culture: 'it',
    cookies: [
      {
        Name: 'test_cookie',
        NamePattern: '',
        Provider: 'doubleclick.net',
        Path: '/',
        Value: 'CheckForPermission',
        HTTPOnly: '0',
        Secure: '1',
        ThirdParty: '1',
        Persistent: '1',
        ExpireSeconds: '891',
        ExpireDays: '1',
        ExpireDescription: '1 giorno',
        TrackerTypeID: '1',
        TrackerTypeAbbr: 'HTTP',
        TrackerTypeName: 'HTTP Cookie',
        Category: '1',
        PurposeDescription: "Utilizzato per verificare se il browser dell'utente supporta i cookie.",
        FirstURL: 'https://www.tassomutuo.it/',
        Initiator: 'https://www.tassomutuo.it/_next/static/chunks/pages/_app-87e0056153535554.js',
        InitiatorSource: 'https://www.tassomutuo.it/_next/static/chunks/pages/_app-87e0056153535554.js',
        InitiatorCodeBlockBegin: '1',
        InitiatorCodeBlockEnd: '1',
        InitiatorCodeLineSpecific: '1',
        InitiatorSourceDomain: 'www.tassomutuo.it',
        InitiatorSourceDomainIP: '104.26.10.14',
        InitiatorSourceDomainCountryID: 'US',
        InitiatorSourceDomainCountryName: 'Stati Uniti',
        GDPRAdequateCountry: '0',
        PriorConsentEnabled: '0',
      },
      {
        Name: 'rc::a',
        NamePattern: '',
        Provider: 'gstatic.com',
        Path: '/',
        Value: 'MW13M2JtcGkyYThoaw==',
        HTTPOnly: '0',
        Secure: '1',
        ThirdParty: '1',
        Persistent: '1',
        ExpireSeconds: '9223372036854775807',
        ExpireDays: '0',
        ExpireDescription: 'Persistent',
        TrackerTypeID: '2',
        TrackerTypeAbbr: 'HTML',
        TrackerTypeName: 'HTML Local Storage',
        Category: '1',
        PurposeDescription:
          "Questo cookie è usato per distinguere tra umani e robot. Questo è utile per il sito web, al fine di rendere validi rapporti sull'uso del sito.",
        FirstURL: 'https://www.tassomutuo.it/',
        Initiator: 'https://www.tassomutuo.it/_next/static/chunks/pages/_app-87e0056153535554.js',
        InitiatorSource: 'https://www.tassomutuo.it/_next/static/chunks/pages/_app-87e0056153535554.js',
        InitiatorCodeBlockBegin: '1',
        InitiatorCodeBlockEnd: '1',
        InitiatorCodeLineSpecific: '1',
        InitiatorSourceDomain: 'www.tassomutuo.it',
        InitiatorSourceDomainIP: '104.26.11.14',
        InitiatorSourceDomainCountryID: 'US',
        InitiatorSourceDomainCountryName: 'Stati Uniti',
        GDPRAdequateCountry: '0',
        PriorConsentEnabled: '0',
      },
      {
        Name: 'rc::c',
        NamePattern: '',
        Provider: 'gstatic.com',
        Path: '/',
        Value: 'BEIlFUUapjmhL_NPdLLE_UlFEwHhVaF7AZvtsqBWNMVlUh7tlTY2jlzazL1NRRa16Y29Cm1iyGacCiXRTRo2oaw',
        HTTPOnly: '0',
        Secure: '1',
        ThirdParty: '1',
        Persistent: '0',
        ExpireSeconds: '0',
        ExpireDays: '0',
        ExpireDescription: 'Session',
        TrackerTypeID: '2',
        TrackerTypeAbbr: 'HTML',
        TrackerTypeName: 'HTML Local Storage',
        Category: '1',
        PurposeDescription: 'Questo cookie è usato per distinguere tra umani e robot.',
        FirstURL: 'https://www.tassomutuo.it/',
        Initiator: 'https://www.tassomutuo.it/_next/static/chunks/pages/_app-87e0056153535554.js',
        InitiatorSource: 'https://www.tassomutuo.it/_next/static/chunks/pages/_app-87e0056153535554.js',
        InitiatorCodeBlockBegin: '1',
        InitiatorCodeBlockEnd: '1',
        InitiatorCodeLineSpecific: '1',
        InitiatorSourceDomain: 'www.tassomutuo.it',
        InitiatorSourceDomainIP: '104.26.10.14',
        InitiatorSourceDomainCountryID: 'US',
        InitiatorSourceDomainCountryName: 'Stati Uniti',
        GDPRAdequateCountry: '0',
        PriorConsentEnabled: '0',
      },
      {
        Name: 'CookieConsent',
        NamePattern: '',
        Provider: 'www.tassomutuo.it',
        Path: '/',
        Value: '{stamp:%27-1%27%2Cnecessary:true%2Cpreferences:true%2Cstatistics:true%2Cmarketing:true%2Cver:99999999999%2Cutc:1690533428336}',
        HTTPOnly: '0',
        Secure: '0',
        ThirdParty: '1',
        Persistent: '1',
        ExpireSeconds: '31536000',
        ExpireDays: '365',
        ExpireDescription: '1 anno',
        TrackerTypeID: '1',
        TrackerTypeAbbr: 'HTTP',
        TrackerTypeName: 'HTTP Cookie',
        Category: '1',
        PurposeDescription: "Memorizza lo stato del consenso ai cookie dell'utente per il dominio corrente",
        FirstURL: 'https://www.tassomutuo.it/',
        Initiator: '',
        InitiatorSource: '',
        InitiatorCodeBlockBegin: '0',
        InitiatorCodeBlockEnd: '0',
        InitiatorCodeLineSpecific: '0',
        InitiatorSourceDomain: 'www.tassomutuo.it',
        InitiatorSourceDomainIP: '104.26.11.14',
        InitiatorSourceDomainCountryID: 'US',
        InitiatorSourceDomainCountryName: 'Stati Uniti',
        GDPRAdequateCountry: '0',
        PriorConsentEnabled: '1',
      },
      {
        Name: 'landedIn',
        NamePattern: '',
        Provider: 'www.tassomutuo.it',
        Path: '/',
        Value: 'home',
        HTTPOnly: '0',
        Secure: '1',
        ThirdParty: '1',
        Persistent: '1',
        ExpireSeconds: '9223372036854775807',
        ExpireDays: '0',
        ExpireDescription: 'Persistent',
        TrackerTypeID: '2',
        TrackerTypeAbbr: 'HTML',
        TrackerTypeName: 'HTML Local Storage',
        Category: '1',
        PurposeDescription: '',
        FirstURL: 'https://www.tassomutuo.it/',
        Initiator: 'https://www.tassomutuo.it/_next/static/chunks/pages/index-d58699a696e7c2b1.js',
        InitiatorSource: 'https://www.tassomutuo.it/_next/static/chunks/pages/index-d58699a696e7c2b1.js',
        InitiatorCodeBlockBegin: '1',
        InitiatorCodeBlockEnd: '1',
        InitiatorCodeLineSpecific: '1',
        InitiatorSourceDomain: 'www.tassomutuo.it',
        InitiatorSourceDomainIP: '104.26.11.14',
        InitiatorSourceDomainCountryID: 'US',
        InitiatorSourceDomainCountryName: 'Stati Uniti',
        GDPRAdequateCountry: '0',
        PriorConsentEnabled: '0',
      },
      {
        Name: 'landingFrom',
        NamePattern: '',
        Provider: 'www.tassomutuo.it',
        Path: '/',
        Value: 'homepage',
        HTTPOnly: '0',
        Secure: '1',
        ThirdParty: '1',
        Persistent: '1',
        ExpireSeconds: '9223372036854775807',
        ExpireDays: '0',
        ExpireDescription: 'Persistent',
        TrackerTypeID: '2',
        TrackerTypeAbbr: 'HTML',
        TrackerTypeName: 'HTML Local Storage',
        Category: '1',
        PurposeDescription: '',
        FirstURL: 'https://www.tassomutuo.it/',
        Initiator: 'https://www.tassomutuo.it/_next/static/chunks/pages/index-d58699a696e7c2b1.js',
        InitiatorSource: 'https://www.tassomutuo.it/_next/static/chunks/pages/index-d58699a696e7c2b1.js',
        InitiatorCodeBlockBegin: '1',
        InitiatorCodeBlockEnd: '1',
        InitiatorCodeLineSpecific: '1',
        InitiatorSourceDomain: 'www.tassomutuo.it',
        InitiatorSourceDomainIP: '104.26.11.14',
        InitiatorSourceDomainCountryID: 'US',
        InitiatorSourceDomainCountryName: 'Stati Uniti',
        GDPRAdequateCountry: '0',
        PriorConsentEnabled: '0',
      },
      {
        Name: '__mp_opt_in_out_50cad616a95bdc722f95cd4c6ebe1e63',
        NamePattern: '',
        Provider: 'tassomutuo.it',
        Path: '/',
        Value: '',
        HTTPOnly: '0',
        Secure: '0',
        ThirdParty: '0',
        Persistent: '0',
        ExpireSeconds: '-86408',
        ExpireDays: '0',
        ExpireDescription: 'Session',
        TrackerTypeID: '1',
        TrackerTypeAbbr: 'HTTP',
        TrackerTypeName: 'HTTP Cookie',
        Category: '3',
        PurposeDescription: '',
        FirstURL: 'https://www.tassomutuo.it/',
        Initiator: 'https://www.tassomutuo.it/_next/static/chunks/pages/_app-87e0056153535554.js',
        InitiatorSource: 'https://www.tassomutuo.it/_next/static/chunks/pages/_app-87e0056153535554.js',
        InitiatorCodeBlockBegin: '1',
        InitiatorCodeBlockEnd: '1',
        InitiatorCodeLineSpecific: '1',
        InitiatorSourceDomain: 'www.tassomutuo.it',
        InitiatorSourceDomainIP: '172.67.68.131',
        InitiatorSourceDomainCountryID: 'US',
        InitiatorSourceDomainCountryName: 'Stati Uniti',
        GDPRAdequateCountry: '0',
        PriorConsentEnabled: '0',
      },
      {
        Name: '_ga',
        NamePattern: '',
        Provider: 'tassomutuo.it',
        Path: '/',
        Value: 'GA1.1.1568588787.1690706226',
        HTTPOnly: '0',
        Secure: '0',
        ThirdParty: '0',
        Persistent: '1',
        ExpireSeconds: '63071991',
        ExpireDays: '730',
        ExpireDescription: '2 anni',
        TrackerTypeID: '1',
        TrackerTypeAbbr: 'HTTP',
        TrackerTypeName: 'HTTP Cookie',
        Category: '3',
        PurposeDescription: 'Registra un ID univoco utilizzato per generare dati statistici su come il visitatore utilizza il sito internet.',
        FirstURL: 'https://www.tassomutuo.it/',
        Initiator: 'https://www.googletagmanager.com/gtag/js?id=G-CP1LH1FC29l=dataLayercx=c',
        InitiatorSource: 'https://www.tassomutuo.it/_next/static/chunks/pages/_app-87e0056153535554.js',
        InitiatorCodeBlockBegin: '1',
        InitiatorCodeBlockEnd: '1',
        InitiatorCodeLineSpecific: '1',
        InitiatorSourceDomain: 'www.googletagmanager.com',
        InitiatorSourceDomainIP: '74.125.193.97',
        InitiatorSourceDomainCountryID: 'US',
        InitiatorSourceDomainCountryName: 'Stati Uniti',
        GDPRAdequateCountry: '0',
        PriorConsentEnabled: '0',
      },
      {
        Name: '_ga_#',
        NamePattern: '',
        Provider: 'tassomutuo.it',
        Path: '/',
        Value: 'deleted',
        HTTPOnly: '0',
        Secure: '0',
        ThirdParty: '0',
        Persistent: '1',
        ExpireSeconds: '63071998',
        ExpireDays: '730',
        ExpireDescription: '2 anni',
        TrackerTypeID: '1',
        TrackerTypeAbbr: 'HTTP',
        TrackerTypeName: 'HTTP Cookie',
        Category: '3',
        PurposeDescription:
          ' Utilizzato da Google Analytics per raccogliere dati sul numero di volte che un utente ha visitato il sito internet, oltre che le dati per la prima visita e la visita più recente.',
        FirstURL: 'https://www.tassomutuo.it/',
        Initiator: 'https://www.googletagmanager.com/gtag/js?id=G-CP1LH1FC29l=dataLayercx=c',
        InitiatorSource: 'https://www.tassomutuo.it/_next/static/chunks/pages/_app-87e0056153535554.js',
        InitiatorCodeBlockBegin: '1',
        InitiatorCodeBlockEnd: '1',
        InitiatorCodeLineSpecific: '1',
        InitiatorSourceDomain: 'www.googletagmanager.com',
        InitiatorSourceDomainIP: '172.253.116.97',
        InitiatorSourceDomainCountryID: 'US',
        InitiatorSourceDomainCountryName: 'Stati Uniti',
        GDPRAdequateCountry: '0',
        PriorConsentEnabled: '0',
      },
      {
        Name: '_hjAbsoluteSessionInProgress',
        NamePattern: '',
        Provider: 'tassomutuo.it',
        Path: '/',
        Value: '0',
        HTTPOnly: '0',
        Secure: '1',
        ThirdParty: '0',
        Persistent: '1',
        ExpireSeconds: '1792',
        ExpireDays: '1',
        ExpireDescription: '1 giorno',
        TrackerTypeID: '1',
        TrackerTypeAbbr: 'HTTP',
        TrackerTypeName: 'HTTP Cookie',
        Category: '3',
        PurposeDescription:
          'Questo cookie viene utilizzato per contare quante volte un sito è stato visto da diversi visitatori; a tale fine viene assegnato al visitatore un numero identificativo casuale, che consente al visitatore di non essere conteggiato due volte.',
        FirstURL: 'https://www.tassomutuo.it/',
        Initiator: 'https://script.hotjar.com/modules.6b15d95870354fc25d31.js',
        InitiatorSource: 'https://www.tassomutuo.it/_next/static/chunks/pages/_app-87e0056153535554.js',
        InitiatorCodeBlockBegin: '1',
        InitiatorCodeBlockEnd: '1',
        InitiatorCodeLineSpecific: '1',
        InitiatorSourceDomain: 'script.hotjar.com',
        InitiatorSourceDomainIP: '18.66.171.20',
        InitiatorSourceDomainCountryID: 'US',
        InitiatorSourceDomainCountryName: 'Stati Uniti',
        GDPRAdequateCountry: '0',
        PriorConsentEnabled: '0',
      },
      {
        Name: '_hjFirstSeen',
        NamePattern: '',
        Provider: 'tassomutuo.it',
        Path: '/',
        Value: '1',
        HTTPOnly: '0',
        Secure: '1',
        ThirdParty: '0',
        Persistent: '1',
        ExpireSeconds: '1792',
        ExpireDays: '1',
        ExpireDescription: '1 giorno',
        TrackerTypeID: '1',
        TrackerTypeAbbr: 'HTTP',
        TrackerTypeName: 'HTTP Cookie',
        Category: '3',
        PurposeDescription: 'Questo cookie viene utilizzato per determinare se il visitatore ha già visitato il sito o se è un nuovo visitatore.',
        FirstURL: 'https://www.tassomutuo.it/',
        Initiator: 'https://script.hotjar.com/modules.6b15d95870354fc25d31.js',
        InitiatorSource: 'https://www.tassomutuo.it/_next/static/chunks/pages/_app-87e0056153535554.js',
        InitiatorCodeBlockBegin: '1',
        InitiatorCodeBlockEnd: '1',
        InitiatorCodeLineSpecific: '1',
        InitiatorSourceDomain: 'script.hotjar.com',
        InitiatorSourceDomainIP: '18.164.52.95',
        InitiatorSourceDomainCountryID: 'US',
        InitiatorSourceDomainCountryName: 'Stati Uniti',
        GDPRAdequateCountry: '0',
        PriorConsentEnabled: '0',
      },
      {
        Name: '_hjIncludedInSessionSample_#',
        NamePattern: '',
        Provider: 'tassomutuo.it',
        Path: '/',
        Value: '1',
        HTTPOnly: '0',
        Secure: '1',
        ThirdParty: '0',
        Persistent: '1',
        ExpireSeconds: '112',
        ExpireDays: '1',
        ExpireDescription: '1 giorno',
        TrackerTypeID: '1',
        TrackerTypeAbbr: 'HTTP',
        TrackerTypeName: 'HTTP Cookie',
        Category: '3',
        PurposeDescription:
          'Raccoglie statistiche sugli accessi al sito internet, come numero di accessi, tempo medio trascorso sul sito internet e quali pagine sono state lette.',
        FirstURL: 'https://www.tassomutuo.it/',
        Initiator: 'https://script.hotjar.com/modules.6b15d95870354fc25d31.js',
        InitiatorSource: 'https://www.tassomutuo.it/_next/static/chunks/pages/_app-87e0056153535554.js',
        InitiatorCodeBlockBegin: '1',
        InitiatorCodeBlockEnd: '1',
        InitiatorCodeLineSpecific: '1',
        InitiatorSourceDomain: 'script.hotjar.com',
        InitiatorSourceDomainIP: '18.164.52.95',
        InitiatorSourceDomainCountryID: 'US',
        InitiatorSourceDomainCountryName: 'Stati Uniti',
        GDPRAdequateCountry: '0',
        PriorConsentEnabled: '0',
      },
      {
        Name: '_hjSession_#',
        NamePattern: '',
        Provider: 'tassomutuo.it',
        Path: '/',
        Value: 'eyJpZCI6Ijk1NjdjZmYzLWUzZDMtNDk4NC1iN2Y3LTZmNDcwZDM3NmI4MCIsImNyZWF0ZWQiOjE2OTA3MDYyMjY0MzEsImluU2FtcGxlIjp0cnVlfQ==',
        HTTPOnly: '0',
        Secure: '1',
        ThirdParty: '0',
        Persistent: '1',
        ExpireSeconds: '1792',
        ExpireDays: '1',
        ExpireDescription: '1 giorno',
        TrackerTypeID: '1',
        TrackerTypeAbbr: 'HTTP',
        TrackerTypeName: 'HTTP Cookie',
        Category: '3',
        PurposeDescription:
          'Raccoglie statistiche sugli accessi al sito internet, come numero di accessi, tempo medio trascorso sul sito internet e quali pagine sono state lette.',
        FirstURL: 'https://www.tassomutuo.it/',
        Initiator: 'https://script.hotjar.com/modules.6b15d95870354fc25d31.js',
        InitiatorSource: 'https://www.tassomutuo.it/_next/static/chunks/pages/_app-87e0056153535554.js',
        InitiatorCodeBlockBegin: '1',
        InitiatorCodeBlockEnd: '1',
        InitiatorCodeLineSpecific: '1',
        InitiatorSourceDomain: 'script.hotjar.com',
        InitiatorSourceDomainIP: '18.165.227.82',
        InitiatorSourceDomainCountryID: 'US',
        InitiatorSourceDomainCountryName: 'Stati Uniti',
        GDPRAdequateCountry: '0',
        PriorConsentEnabled: '0',
      },
      {
        Name: '_hjSessionUser_#',
        NamePattern: '',
        Provider: 'tassomutuo.it',
        Path: '/',
        Value: 'eyJpZCI6ImExN2RmMzgzLTg0OTYtNTQxNy1iYzBkLWUzZjRiNjQ2NjU1OSIsImNyZWF0ZWQiOjE2OTA3MDYyMjY0MTksImV4aXN0aW5nIjpmYWxzZX0=',
        HTTPOnly: '0',
        Secure: '1',
        ThirdParty: '0',
        Persistent: '1',
        ExpireSeconds: '31535992',
        ExpireDays: '365',
        ExpireDescription: '1 anno',
        TrackerTypeID: '1',
        TrackerTypeAbbr: 'HTTP',
        TrackerTypeName: 'HTTP Cookie',
        Category: '3',
        PurposeDescription:
          'Raccoglie statistiche sugli accessi al sito internet, come numero di accessi, tempo medio trascorso sul sito internet e quali pagine sono state lette.',
        FirstURL: 'https://www.tassomutuo.it/',
        Initiator: 'https://script.hotjar.com/modules.6b15d95870354fc25d31.js',
        InitiatorSource: 'https://www.tassomutuo.it/_next/static/chunks/pages/_app-87e0056153535554.js',
        InitiatorCodeBlockBegin: '1',
        InitiatorCodeBlockEnd: '1',
        InitiatorCodeLineSpecific: '1',
        InitiatorSourceDomain: 'script.hotjar.com',
        InitiatorSourceDomainIP: '18.165.227.82',
        InitiatorSourceDomainCountryID: 'US',
        InitiatorSourceDomainCountryName: 'Stati Uniti',
        GDPRAdequateCountry: '0',
        PriorConsentEnabled: '0',
      },
      {
        Name: '_hjTLDTest',
        NamePattern: '',
        Provider: 'tassomutuo.it',
        Path: '/',
        Value: '.tassomutuo.it',
        HTTPOnly: '0',
        Secure: '1',
        ThirdParty: '0',
        Persistent: '0',
        ExpireSeconds: '-86407',
        ExpireDays: '0',
        ExpireDescription: 'Session',
        TrackerTypeID: '1',
        TrackerTypeAbbr: 'HTTP',
        TrackerTypeName: 'HTTP Cookie',
        Category: '3',
        PurposeDescription:
          "Registra dati statistici sul comportamento dei utenti sul sito web. Questi vengono utilizzati per l'analisi interna dall'operatore del sito.",
        FirstURL: 'https://www.tassomutuo.it/',
        Initiator: 'https://script.hotjar.com/modules.6b15d95870354fc25d31.js',
        InitiatorSource: 'https://www.tassomutuo.it/_next/static/chunks/pages/_app-87e0056153535554.js',
        InitiatorCodeBlockBegin: '1',
        InitiatorCodeBlockEnd: '1',
        InitiatorCodeLineSpecific: '1',
        InitiatorSourceDomain: 'script.hotjar.com',
        InitiatorSourceDomainIP: '18.66.171.32',
        InitiatorSourceDomainCountryID: 'US',
        InitiatorSourceDomainCountryName: 'Stati Uniti',
        GDPRAdequateCountry: '0',
        PriorConsentEnabled: '0',
      },
      {
        Name: 'IDE',
        NamePattern: '',
        Provider: 'doubleclick.net',
        Path: '/',
        Value: 'AHWqTUm9-ayMKlUZbdgHqK1UnxMXLQKzwk1rLjtPGJlBOgS5Fvu0M9cJ1F2ECTee',
        HTTPOnly: '1',
        Secure: '1',
        ThirdParty: '1',
        Persistent: '1',
        ExpireSeconds: '33695991',
        ExpireDays: '390',
        ExpireDescription: '1 anno',
        TrackerTypeID: '1',
        TrackerTypeAbbr: 'HTTP',
        TrackerTypeName: 'HTTP Cookie',
        Category: '4',
        PurposeDescription:
          "Utilizzato da Google DoubleClick per registrare e produrre resoconti sulle azioni dell'utente sul sito dopo aver visualizzato o cliccato una delle pubblicità dell'inserzionista al fine di misurare l'efficacia di una pubblicità e presentare pubblicità mirata all'utente.",
        FirstURL: 'https://www.tassomutuo.it/',
        Initiator: '',
        InitiatorSource: '',
        InitiatorCodeBlockBegin: '0',
        InitiatorCodeBlockEnd: '0',
        InitiatorCodeLineSpecific: '0',
        InitiatorSourceDomain: 'doubleclick.net',
        InitiatorSourceDomainIP: '74.125.193.102',
        InitiatorSourceDomainCountryID: 'US',
        InitiatorSourceDomainCountryName: 'Stati Uniti',
        GDPRAdequateCountry: '0',
        PriorConsentEnabled: '1',
      },
      {
        Name: 'pagead/1p-user-list/11093796799/',
        NamePattern: '',
        Provider: 'google.com',
        Path: '/',
        Value: 'random=nacv=nafst=nabg=naguid=naasync=nagtm=nau_w=nau_h=naurl=nafrm=natiba=nafmt=nais_vtc=narmt_tld=naipr=na',
        HTTPOnly: '0',
        Secure: '1',
        ThirdParty: '1',
        Persistent: '0',
        ExpireSeconds: '0',
        ExpireDays: '0',
        ExpireDescription: 'Session',
        TrackerTypeID: '5',
        TrackerTypeAbbr: 'Pixel',
        TrackerTypeName: 'Pixel Tracker',
        Category: '4',
        PurposeDescription: '',
        FirstURL: 'https://www.tassomutuo.it/',
        Initiator: 'https://www.tassomutuo.it/_next/static/chunks/pages/_app-87e0056153535554.js',
        InitiatorSource: 'https://www.tassomutuo.it/_next/static/chunks/pages/_app-87e0056153535554.js',
        InitiatorCodeBlockBegin: '1',
        InitiatorCodeBlockEnd: '1',
        InitiatorCodeLineSpecific: '1',
        InitiatorSourceDomain: 'www.tassomutuo.it',
        InitiatorSourceDomainIP: '104.26.11.14',
        InitiatorSourceDomainCountryID: 'US',
        InitiatorSourceDomainCountryName: 'Stati Uniti',
        GDPRAdequateCountry: '0',
        PriorConsentEnabled: '1',
      },
      {
        Name: '_gcl_au',
        NamePattern: '',
        Provider: 'tassomutuo.it',
        Path: '/',
        Value: '1.1.1214840675.1690706225',
        HTTPOnly: '0',
        Secure: '0',
        ThirdParty: '0',
        Persistent: '1',
        ExpireSeconds: '7775991',
        ExpireDays: '90',
        ExpireDescription: '3 mesi',
        TrackerTypeID: '1',
        TrackerTypeAbbr: 'HTTP',
        TrackerTypeName: 'HTTP Cookie',
        Category: '4',
        PurposeDescription:
          "Utilizzato da Google AdSense per sperimentare l'efficacia pubblicitaria su tutti i siti web che utilizzano i loro servizi.",
        FirstURL: 'https://www.tassomutuo.it/',
        Initiator: 'https://www.googletagmanager.com/gtm.js?id=GTM-DRHC5QQgtm_auth=gtm_preview=gtm_cookies_win=x',
        InitiatorSource: 'https://www.tassomutuo.it/_next/static/chunks/pages/_app-87e0056153535554.js',
        InitiatorCodeBlockBegin: '1',
        InitiatorCodeBlockEnd: '1',
        InitiatorCodeLineSpecific: '1',
        InitiatorSourceDomain: 'www.googletagmanager.com',
        InitiatorSourceDomainIP: '74.125.193.97',
        InitiatorSourceDomainCountryID: 'US',
        InitiatorSourceDomainCountryName: 'Stati Uniti',
        GDPRAdequateCountry: '0',
        PriorConsentEnabled: '0',
      },
      {
        Name: 'mp_#_mixpanel',
        NamePattern: '',
        Provider: 'tassomutuo.it',
        Path: '/',
        Value: '',
        HTTPOnly: '0',
        Secure: '0',
        ThirdParty: '0',
        Persistent: '1',
        ExpireSeconds: '31535991',
        ExpireDays: '365',
        ExpireDescription: '1 anno',
        TrackerTypeID: '1',
        TrackerTypeAbbr: 'HTTP',
        TrackerTypeName: 'HTTP Cookie',
        Category: '4',
        PurposeDescription: '',
        FirstURL: 'https://www.tassomutuo.it/',
        Initiator: 'https://www.tassomutuo.it/_next/static/chunks/pages/_app-87e0056153535554.js',
        InitiatorSource: 'https://www.tassomutuo.it/_next/static/chunks/pages/_app-87e0056153535554.js',
        InitiatorCodeBlockBegin: '1',
        InitiatorCodeBlockEnd: '1',
        InitiatorCodeLineSpecific: '1',
        InitiatorSourceDomain: 'www.tassomutuo.it',
        InitiatorSourceDomainIP: '104.26.10.14',
        InitiatorSourceDomainCountryID: 'US',
        InitiatorSourceDomainCountryName: 'Stati Uniti',
        GDPRAdequateCountry: '0',
        PriorConsentEnabled: '0',
      },
      {
        Name: 'mp_#_mixpanel',
        NamePattern: '',
        Provider: 'www.tassomutuo.it',
        Path: '/',
        Value: '{}',
        HTTPOnly: '0',
        Secure: '0',
        ThirdParty: '1',
        Persistent: '1',
        ExpireSeconds: '31535991',
        ExpireDays: '365',
        ExpireDescription: '1 anno',
        TrackerTypeID: '1',
        TrackerTypeAbbr: 'HTTP',
        TrackerTypeName: 'HTTP Cookie',
        Category: '4',
        PurposeDescription: '',
        FirstURL: 'https://www.tassomutuo.it/',
        Initiator: 'https://www.tassomutuo.it/_next/static/chunks/pages/_app-87e0056153535554.js',
        InitiatorSource: 'https://www.tassomutuo.it/_next/static/chunks/pages/_app-87e0056153535554.js',
        InitiatorCodeBlockBegin: '1',
        InitiatorCodeBlockEnd: '1',
        InitiatorCodeLineSpecific: '1',
        InitiatorSourceDomain: 'www.tassomutuo.it',
        InitiatorSourceDomainIP: '172.67.68.131',
        InitiatorSourceDomainCountryID: 'US',
        InitiatorSourceDomainCountryName: 'Stati Uniti',
        GDPRAdequateCountry: '0',
        PriorConsentEnabled: '0',
      },
    ],
  };

  return cookies;
}
